<template>
	<div class="w-100 d-flex justify-content-center mr-5">
		<div
			:class="['first-circle', { animate: firstCircleAnimate }]"
			:style="{ background: firstCircleBackground }"
		></div>
		<div :class="['firstmid-circle', { animate: firstMidCircleAnimate }]"></div>

		<div
			class="position-relative"
			:class="['second-circle', { animate: secondRectangleAnimate }]"
			:style="{ background: secondBgColor }"
		>
			<div class="white-line"></div>
			<div class="white-round"></div>
		</div>
	</div>
</template>

<script>
export default {
	name: "MobileSpinner",
	props: {
		id: {
			type: String,
			default: "",
		},
	},
	data() {
		return {
			firstCircleAnimate: false,
			firstMidCircleAnimate: false,
			midContentAnimate: false,
			secondRectangleAnimate: false,
			firstCircleBackground: "#f0f6ff",
			secondBgColor: "#ebedf0",
			timeouts: [],
			intervals: null,
		};
	},
	mounted() {
		document.addEventListener("visibilitychange", () => {
			if (document.hidden) {
				this.timeouts.forEach((timeout) => {
					clearTimeout(timeout);
				});
				clearInterval(this.intervals);
			} else {
				this.restartAnimationCycle();
				this.intervals = setInterval(() => {
					this.restartAnimationCycle();
				}, 1500);
			}
		});

		this.restartAnimationCycle();
		this.intervals = setInterval(() => {
			this.restartAnimationCycle();
		}, 1500);
	},
	methods: {
		async triggerAnimationCycle() {
			this.timeouts.push(
				setTimeout(() => {
					this.firstCircleAnimate = true;
					this.firstCircleBackground = "#f0f6ff";
				}, 300)
			);
			this.timeouts.push(
				setTimeout(() => {
					this.firstCircleBackground = "unset";
					this.firstMidCircleAnimate = true;
				}, 700)
			);
			this.timeouts.push(
				setTimeout(() => {
					this.firstCircleBackground = "unset";
					this.secondRectangleAnimate = true;
					this.secondBgColor = "#ebedf0";
				}, 1100)
			);
			this.firstCircleBackground = "#f0f6ff";
		},
		async restartAnimationCycle() {
			this.timeouts = [];
			this.firstCircleAnimate = false;
			this.firstMidCircleAnimate = false;
			this.secondRectangleAnimate = false;

			this.triggerAnimationCycle();
		},
	},
};
</script>

<style scoped>
.first-circle {
	width: 25px;
	height: 25px;
	border-top-left-radius: 50px;
	border-bottom-left-radius: 50px;
	transform: rotate(49deg);
	z-index: 8999;
	background: #f0f6ff;
	overflow: hidden;
	margin-top: 75px;
}

.first-circle::before {
	position: absolute;
	content: "";
	bottom: 0px;
	left: 0px;
	width: 0;
	height: 100%;
	background-color: #68a5ff;
	transition: width 0.4s linear;
	z-index: -1;
}

.first-circle.animate::before {
	width: 100%;
	animation: growWidth 0.4s linear forwards;
}

@keyframes growWidth {
	from {
		width: 0%;
	}
	to {
		width: 100%;
	}
}
.firstmid-circle {
	height: 10px;
	width: 10px;
	border-bottom-right-radius: 100%;
	border-top-right-radius: 0px;
	z-index: 500;
	transform: rotate(48deg);
	margin-top: 32px;
	background: #f0f6ff;
	overflow: hidden;
	margin-top: 90px;
}

.firstmid-circle::before {
	position: absolute;
	content: "";
	bottom: 0px;
	left: 0px;
	width: 0;
	height: 100%;
	background-color: #68a5ff;
	transition: width 0.2s linear;
	z-index: -1;
}

.firstmid-circle.animate::before {
	width: 100%;
	animation: growMidWidth 0.2s linear forwards;
}

@keyframes growMidWidth {
	from {
		width: 0%;
	}
	to {
		width: 100%;
	}
}

.second-circle {
	width: 25px;
	height: 100px;
	transform: rotate(49deg);
	margin-left: 10px;
	border-top-left-radius: 50px;
	border-top-right-radius: 50px;
	border-bottom-right-radius: 22px;
	position: relative;
	margin-top: 32px;
	background: #ebedf0;
}

.second-circle::before {
	position: absolute;
	content: "";
	bottom: 0px;
	left: 0px;
	width: 100%;
	height: 0;
	background-color: #344966;
	transition: height 0.3s linear;
	z-index: -1;
	border-top-left-radius: 50px;
	border-top-right-radius: 50px;
	border-bottom-right-radius: 22px;
}

.second-circle.animate::before {
	height: 100%;
	animation: growsecondWidth 0.3s linear forwards;
}

@keyframes growsecondWidth {
	from {
		height: 0%;
	}
	to {
		height: 100%;
	}
}

.white-round {
	position: absolute;
	bottom: 14px;
	left: 0px;
	height: 14px;
	width: 14px;
	border-radius: 0px 246px 0 0;
	background-color: #fff;
	transform: rotate(89deg);
}

.white-line {
	position: absolute;
	bottom: 0px;
	height: 23px;
	width: 4px;
	background: #fff;
}
</style>
